(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('UserSearchPaginationService', ['$rootScope', 'HelperService', 'UserService', 'UserFilterService', 'UserBroadcast', '$filter', 'ItemsPerPage', UserSearchPaginationServiceFn]);

    // service to handle overview specific things like pagination and filtering
    function UserSearchPaginationServiceFn($rootScope, HelperService, UserService, UserFilterService, UserBroadcast, $filter, ItemsPerPage) {

        var data = {
            // pagination data
            pagination: {
                currentPage: 1,
                itemsPerPage: ItemsPerPage.Default.value,
                includeCount: true,
                searchFilter: null,
                roles: [],
                sharedAgendaOwnerIds: []
            },

            syncedOnly: false,
            syncInactive: false,
            nonSyncedOnly: false,

            active: false,
            blocked: false,
            deleted: false,

            results: [], // result list (filtered and paginated)

            total: 0, // counter on items currently selected/filtered 
            roleCounts: [],

            userId: null,
            agendaId: null

        };

        // service class
        var service = {
            data: data,
            paginate: paginate,
            init: init,
            search: search
        };
        return service;

        // calculate filtered array (pagination)
        function paginate() {
            data.pagination.includeCount = false;
            
            UserService.subusers(data.userId, data.agendaId, data.active, data.blocked, data.deleted, data.pagination, data.syncedOnly, !data.syncInactive, data.nonSyncedOnly).then(function (result) {
                data.results = result.results;
                data.roleCounts = result.roleCounts;
            });
        } // paginate

        // search
        function search() {
            // init
            data.pagination.includeCount = true;
            data.pagination.currentPage = 1;

            return UserService.subusers(data.userId, data.agendaId, data.active,data.blocked,data.deleted, data.pagination, data.syncedOnly, !data.syncInactive, data.nonSyncedOnly).then(function (result) {
                data.results = result.results;
                data.total = result.total;
                data.roleCounts = result.roleCounts;

                // calculate/set Badge-Counts on several Filters
                $rootScope.$broadcast(UserBroadcast.FilterCalculate);
                
            });
        }


        /* init */
        function init(userId, agendaId, syncedOnly, itemsPerPage, agendaUserIds, roles) {
            // Clean Up
            clean();

            // Get Filter-Values From LocalStorage
            data.pagination.roles = roles || UserFilterService.loadRoleFilter().map(function (item) { return item.value; });
            data.pagination.itemsPerPage = itemsPerPage || ItemsPerPage.Default.value;

            data.pagination.sharedAgendaOwnerIds = agendaUserIds || [];

            data.userId = userId;
            data.agendaId = agendaId;
            
            data.syncedOnly = syncedOnly;

        } // init


        // clean
        function clean() {
            //data.items = [];
            //data.filteredItems = [];
            data.results = [];
            data.userId = null;
            data.agendaId = null;
            data.syncedOnly = false;
            data.syncInactive = false;
            data.nonSyncedOnly = false;
            data.total = 0;
            data.pagination.includeCount = true;
            data.pagination.searchFilter = null;
            data.pagination.roles = [];
            data.roleCounts = [];
        } // clean 

    }
})();